/**
 * App colors.
 */
export const bgDarkBlue = '#21252b';
export const bgMidBlue = '#282c34';
export const bgLightBlue = '#333842';
export const lbIconColor = '#9599a0';

export const textWhite = '#f3f3f3';
export const textMid = '#c2c2c2';
export const textDark = '#909295';
export const textBlue = '#636d83';
export const textLightBlue = '#abb2bf';

export const green = '#98c379';
export const red = '#e06c75';
export const cyan = '#56b6c2';
export const midBlue = '#42a5f5';
export const orange = '#d19a66';
export const jsOrange = '#ffca28';
export const darkOrange = '#e44d26';
export const lightBrown = '#6e6352';
export const pink = '#e13e76';
export const purple = '#c678dd';
